import { DataConditionPlugin } from './DataCondition';
import { UserDataFieldConditionPlugin } from './UserDataFieldCondition';

export const defaultTransitionConditionPlugins = [
  DataConditionPlugin,
  UserDataFieldConditionPlugin
];
